export const MESSAGE = 'Router error';

export class RouteError extends Error {
  constructor() {
    super(MESSAGE);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/error/route-error.ts